import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-2 sm:grid-cols-3 py-12" }
const _hoisted_2 = { class: "flex flex-col items-center" }
const _hoisted_3 = { class: "flex items-center pl-16" }
const _hoisted_4 = { class: "ml-2 w-16 text-lg" }
const _hoisted_5 = { class: "flex flex-col items-center justify-center" }
const _hoisted_6 = { class: "flex flex-col items-center" }
const _hoisted_7 = { class: "flex items-center pr-16" }
const _hoisted_8 = { class: "mr-2 w-16 text-lg text-right" }

import { computed, ref } from "vue";
import Title from "@/components/Title.vue";
import { ScaleIcon } from '@heroicons/vue/24/outline';
import Vue3Slider from "vue3-slider"
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RuleOf40View',
  setup(__props) {

const growth = ref(15);
const profitability = ref(25);
const ruleOf40 = computed(() => growth.value + profitability.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, { subtitle: "Resources" }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("Rule of 40")
      ])),
      _: 1,
      __: [2]
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "pb-8" }, " The \"Rule of 40\" is a financial metric used in the technology industry, particularly among SaaS companies and startups, to assess the balance between a company's growth and profitability. It's main use is to to evaluate the overall health and sustainability of a company. ", -1)),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "sm:mx-40 p-2 text-green-800 border-t-4 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-700 dark:border-green-800 text-lg font-medium" }, " The \"Rule of 40\" suggests that if the sum of the revenue growth rate and the EBITDA margin percentage is equal to or greater than 40, the company is in a healthy financial position. ", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "text-3xl font-bold" }, "Growth", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-5" }, "Revenue Growthe Rate", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-1 text-xs" }, "Revenue Growth", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Vue3Slider), {
                modelValue: growth.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((growth).value = $event)),
                width: "200px",
                height: "10",
                step: 5,
                min: -40,
                max: 40,
                orientation: "vertical",
                color: "#333",
                "track-color": "#ddd"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(growth.value) + "%", 1)
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mt-1 text-xs" }, "Revenue Decline", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(ScaleIcon), { class: "block w-20 h-20 mb-2" }),
            _createElementVNode("div", {
              class: _normalizeClass([
            'flex justify-center items-center w-24 h-24 rounded-full text-4xl text-white dark:text-primary',
            ruleOf40.value >= 40 ? 'bg-green-500' : 'bg-red-500',
          ])
            }, _toDisplayString(ruleOf40.value) + "% ", 3)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "text-3xl font-bold" }, "Profitability", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mb-5" }, "EBITDA Margin Percentage", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mb-1 text-xs" }, "Profits", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(profitability.value) + "%", 1),
              _createVNode(_unref(Vue3Slider), {
                modelValue: profitability.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profitability).value = $event)),
                width: "200px",
                height: "10",
                step: 5,
                min: -40,
                max: 40,
                tooltip: "",
                orientation: "vertical",
                color: "#333",
                "track-color": "#ddd"
              }, null, 8, ["modelValue"])
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mt-1 text-xs" }, "Losses", -1))
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "grid gap-2 sm:grid-cols-3" }, [
          _createElementVNode("div", { class: "text-center text-sm" }, [
            _createElementVNode("p", { class: "mb-2" }, [
              _createElementVNode("b", null, "Revenue Growth"),
              _createTextVNode(" is simply the difference in revenue between two points in time. The percentage of this change is the "),
              _createElementVNode("b", null, "Revenue Growth Rate"),
              _createTextVNode(". ")
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(" Last year's revenue: $2,000,000"),
              _createElementVNode("br"),
              _createTextVNode(" This year's revenue: $2,500,000"),
              _createElementVNode("br"),
              _createTextVNode(" Revenue Growth: $500,000"),
              _createElementVNode("br"),
              _createTextVNode(" Revenue Growth Rate: 25% ")
            ])
          ]),
          _createElementVNode("div"),
          _createElementVNode("div", { class: "text-center text-sm" }, [
            _createElementVNode("p", { class: "mb-2" }, [
              _createElementVNode("b", null, "EBITDA"),
              _createTextVNode(" is Earnings Before Interest, Taxes, Depreciation, and Amortization. It is a rough proxy for the cash flow generated by a company. The "),
              _createElementVNode("b", null, "EBITDA Margin"),
              _createTextVNode(" is calculated by comparing the EBITDA to the revenue. ")
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(" EBITDA: $500,000"),
              _createElementVNode("br"),
              _createTextVNode(" Revenue: $2,500,000"),
              _createElementVNode("br"),
              _createTextVNode(" EBITDA Margin: 20% ")
            ])
          ])
        ], -1))
      ]),
      _: 1,
      __: [11,12,13]
    })
  ], 64))
}
}

})